/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Double_Height_NoInputs */



/**
* | output |
* | --- |
* | "No" |
*
* @param {Embed_Captions_Local_Double_Height_NoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_double_height_no = /** @type {((inputs?: Embed_Captions_Local_Double_Height_NoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Double_Height_NoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nein")
	if (locale === "it") return /** @type {LocalizedString} */ ("No")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет")
	if (locale === "es") return /** @type {LocalizedString} */ ("No")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("否")
	if (locale === "ja") return /** @type {LocalizedString} */ ("いいえ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não")
	return /** @type {LocalizedString} */ ("No")
});